// src/utils/notification.js
export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    console.log("This browser does not support notifications");
    return false;
  }

  if (Notification.permission === "granted") {
    console.log("Notification permission already granted");
    return true;
  }

  if (Notification.permission !== "denied") {
    const permission = await Notification.requestPermission();
    
    if (permission === "granted") {
      console.log("Notification permission granted");
      return true;
    }
  }
  
  return false;
};

// Simple notification without actions (for foreground)
export const showSimpleNotification = (title, options = {}) => {
  if (Notification.permission !== "granted") {
    console.warn("Notification permission not granted");
    return null;
  }

  // ORDER NOTIFICATION ONLY
  if (!options.data?.order_id && !options.data?.type?.includes('order')) {
    console.log("Ignoring non-order notification");
    return null;
  }

  const notificationOptions = {
    body: options.body || "",
    icon: options.icon || "/icon/navigation.png",
    data: options.data || {},
    silent: options.silent || false,
    tag: options.tag || `order-${options.data?.order_id}`,
    renotify: true
  };

  const notification = new Notification(title, notificationOptions);

  // Notification click handler
  notification.onclick = function (event) {
    event.preventDefault();
    
    if (options.data?.orderId) {
      window.location.href = `/delivery/orders/${options.data.orderId}`;
    } else if (options.data?.url) {
      window.location.href = options.data.url;
    }
    
    notification.close();
  };

  // Auto close after 10 seconds
  setTimeout(() => {
    notification.close();
  }, 10000);

  return notification;
};

// Send notification via service worker (with actions)
export const sendNotificationViaServiceWorker = async (title, options = {}) => {
  try {
    if (!navigator.serviceWorker || !navigator.serviceWorker.controller) {
      console.warn("Service worker not available, falling back to simple notification");
      return showSimpleNotification(title, options);
    }

    // ORDER NOTIFICATION ONLY
    if (!options.data?.order_id && !options.data?.type?.includes('order')) {
      console.log("Ignoring non-order notification for service worker");
      return null;
    }

    // Send message to service worker
    navigator.serviceWorker.controller.postMessage({
      type: 'SHOW_NOTIFICATION',
      title: title,
      options: {
        body: options.body || "",
        data: options.data || {},
        tag: options.tag || `notification-${Date.now()}`,
        icon: options.icon || "/icon/navigation.png"
      }
    });

    console.log("Notification sent to service worker");
  } catch (error) {
    console.error("Error sending notification via service worker:", error);
    // Fallback to simple notification
    return showSimpleNotification(title, options);
  }
};